//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginInput from "../input/loginInput";
import { CacheModule } from "@/utils/commonUtils";
import { loginMobile } from "@/model/api/loginService.js";
import { phoneReg, nameReg, codeReg } from "@/utils/regular.js";
import { store, mutations } from "@/observable/store";
export default {
	data() {
		return {
			img: "https://static.soyoung.com/sy-pre/bg_img-1566375004168.png",
			show: false,
			orderFlag: null,
			applicantPhone: "",
			applicantCode: "",
			codeClickFlag: true,
			showTime: true,
			count: "",
			timer: null,
			selectFlag: false,
		};
	},
	components: {
		LoginInput,
	},
	props: {
		accountRule: {
			type: [String, Number],
			default: 0,
		},
		mainHead: {
			// 主标题
			type: String,
			default() {
				return "欢迎登录金保信";
			},
		},
		subHead: {
			// 副标题
			type: String,
			default() {
				return "新用户登录后将自动为您注册账号";
			},
		},
		fontColor: {
			// 字体颜色
			type: String,
			default() {
				return "#00ab84";
			},
		},
		bgColor: {
			//按钮背景颜色
			type: Object,
			default() {
				return {
					bgImage: "linear-gradient(47deg, #00ab84 0%, #00ab84 100%)",
					boxShadow: "0 2px 8px 0 #00ab84",
				};
			},
		},
		borderColor: {
			// border 颜色
			type: String,
			default() {
				return "";
			},
			// 1px solid rgba(255,142,163,1)
		},
		returnKey: {
			// 用于区分同一个页面 登录成功后 存在多个登录事件 。否则忽略
			type: String,
			default() {
				return "";
			},
		},
	},
	computed: {
		uid() {
			return store.uid;
		},
		loginPhone() {
			let tel = String(store.phone);
			let phone = tel.substr(0, 3) + "xxxx" + tel.substr(7);
			return phone;
		},
	},
	mounted() {
		if (this.$route.params.show) {
			this.showoast();
			this.$nextTick(() => {
				this.$refs.LoginInput.setdata(this.$route.params.data);
			});
		}
	},
	methods: {
		showoast() {
			// this.orderFlag = e
			this.show = true;
			this.STATISTICS_CONFIG.insur_register_click();
		},
		codeClick(msg) {
			this.applicantPhone = msg.applicantPhone;
			this.applicantCode = msg.applicantCode;
		},
		// author(){
		//     this.STATISTICS_CONFIG.insur_register_clause_click()

		//   let query = {
		//       applicantPhone:this.$refs.LoginInput.applicantPhone,
		//   }
		//   if(this.returnKey ){
		//     query.returnKey = this.returnKey
		//   }
		//   this.$router.push({
		//     path: "/authorization",
		//     query:query
		//   });
		// },
		cellClick(item) {
			//查看用户服务协议和隐私政策
			const pdfUrl =
				item === "privcy"
					? "https://static.soyoung.com/sy-pre/nispvk91jre-1645668600705.pdf"
					: "https://static.soyoung.com/sy-pre/33oqpfw3lc7q3-1646212200700.pdf";
			const url = `${encodeURIComponent(
				pdfUrl
			)}`;
			this.$router.push({
				path: "/webpdf",
				query: {
					file: url
				},
				flag: "postdisable",
			});
		},
		//关闭弹框
		closeClick() {
			this.show = false;
		},
		// 是否勾选
		selectClick() {
			this.selectFlag = !this.selectFlag;
		},
		//登陆
		login() {
			this.STATISTICS_CONFIG.insur_register_go_click();
			this.applicantPhone = this.applicantPhone.trim();
			let PhoneFlag = phoneReg.test(this.applicantPhone);
			// TODO: phoneFlag判断不准确 -> 未点击「获取验证码」时，无法更新applicantPhone/没有输入验证码时，验证不通过
			if (!PhoneFlag) {
				this.$toast("请填写您的手机号码");
				return;
			}
			// 判断验证码是否位纯数字
			this.applicantCode = this.applicantCode.trim();
			let codeTest = codeReg.test(this.applicantCode);
			if (!codeTest) {
				this.$toast("请填写验证码");
				return;
			}
			if (!this.selectFlag) {
				this.$toast("请勾选用户服务协议和隐私政策");
				return;
			}
			let codeData = {
				phone: this.applicantPhone,
				country_code: "86",
				code: this.applicantCode,
				sys: "15",
				account_rule: this.accountRule || 0,
			};
			loginMobile(codeData)
				.then((data) => {
					//console.log('data登录成功',data)
          localStorage.removeItem("Disagree_User_Agreement")
					mutations.getsyToken(data.token);
					mutations.getUid(data.uid);
					// let seconds = '864000';
					// document.cookie="login_token="+data.token;
					// document.cookie="login_uid="+data.uid;
					// document.cookie="login_phone="+data.phone;

					let userInfo = {
						login_token: data.token,
						login_uid: data.uid,
						login_phone: data.phone,
						login_insure_uid: data.insure_uid,
					};
					CacheModule.set("userInfo", userInfo);
					CacheModule.getUserInfo("userInfo");
					// if(this.orderFlag == 1){
					//     this.$parent.getUserinfo()
					// }
					// if(this.orderFlag == 2){
					//     this.$parent.insureInfo()
					// }
					// if(this.orderFlag == 3){
					//     this.$parent.getState()
					// }
					// if(this.orderFlag == 4){
					//     this.$parent.goPay()
					// }
					let key = "";
					if (this.$route.params.data) {
						key = this.$route.params.data.returnKey || this.returnKey;
					} else {
						key = this.returnKey;
					}
					this.$emit("loginCallback", { returnKey: key });
					this.show = false;
					// window.statistics_common.handleBedDataClick('sybao_ins_login_confirm_click', 'from_action='+ this.$route.query.from_action + '&from_salesman='+ this.$route.query.from_salesman + '&activity_id=1001', null)
					this.STATISTICS("click", "sybao_ins_login_confirm_click");
				})
				.catch((err) => {
					this.$toast(err.message);

					//console.log('data登录失败',err)
				});
		},
	},
};
